import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-04_recruitment_signing",
  "use": "icon-04_recruitment_signing-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-04_recruitment_signing\"><path d=\"M15.252 2.22H2.192v19.5h7v-1.5h-5.5V3.72h10.5v4h4v2.5h1.5V6.66l-4.44-4.44zm1.879 4h-1.44V4.78l1.44 1.44z\" /><path d=\"M10.691 7.22h-4.5v1.5h4.5v-1.5zM6.191 11.22h7.5v1.5h-7.5v-1.5zM10.691 15.22h-4.5v1.5h4.5v-1.5zM18.275 11.601l3.532 3.532-6.386 6.387-3.785.257.253-3.79 6.386-6.386zm0 2.121l-4.927 4.928-.101 1.514 1.511-.103 4.928-4.928-1.411-1.41z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol